const DuplexTriplex: any = (
  style = {},
  fill = '#000',
  width = '100%',
  height = '100%',
  viewBox = '0 0 57 53',
) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M0.886428 11.5067C0.609405 11.5067 0.336807 11.3774 0.164221 11.1341C-0.118112 10.7358 -0.0251811 10.1826 0.373095 9.90029L14.0915 0.164657C14.4906 -0.117677 15.0429 -0.0247455 15.3261 0.374415C15.6085 0.772691 15.5155 1.32585 15.1173 1.60819L1.39888 11.3438C1.24222 11.4536 1.06344 11.5067 0.886428 11.5067Z"
      fill={fill}
    />
    <path
      d="M28.321 11.5061C28.144 11.5061 27.9652 11.453 27.8094 11.3424L14.091 1.60672C13.6927 1.32439 13.5989 0.771226 13.8821 0.372951C14.1654 -0.0262104 14.7167 -0.119141 15.1168 0.163192L28.8352 9.89882C29.2335 10.1812 29.3273 10.7343 29.0441 11.1326C28.8706 11.3769 28.5989 11.5061 28.321 11.5061Z"
      fill={fill}
    />
    <path
      d="M0.886428 15.0462C0.609405 15.0462 0.336807 14.917 0.164221 14.6736C-0.118112 14.2753 -0.0251811 13.7222 0.373095 13.4398L14.0915 3.70421C14.4906 3.42187 15.0429 3.51481 15.3261 3.91397C15.6085 4.31224 15.5155 4.8654 15.1173 5.14774L1.39888 14.8834C1.24222 14.9931 1.06344 15.0462 0.886428 15.0462Z"
      fill={fill}
    />
    <path
      d="M28.321 15.0461C28.144 15.0461 27.9652 14.993 27.8094 14.8824L14.091 5.14676C13.6927 4.86443 13.5989 4.31127 13.8821 3.91299C14.1654 3.51383 14.7167 3.4209 15.1168 3.70323L28.8352 13.4389C29.2335 13.7212 29.3273 14.2744 29.0441 14.6726C28.8706 14.9169 28.5989 15.0461 28.321 15.0461Z"
      fill={fill}
    />
    <path
      d="M0.885057 15.0462C0.395621 15.0462 0 14.6497 0 14.1611V10.6209C0 10.1323 0.395621 9.73584 0.885057 9.73584C1.37449 9.73584 1.77011 10.1323 1.77011 10.6209V14.1611C1.77011 14.6497 1.37449 15.0462 0.885057 15.0462Z"
      fill={fill}
    />
    <path
      d="M28.3218 15.0462C27.8324 15.0462 27.4368 14.6497 27.4368 14.1611V10.6209C27.4368 10.1323 27.8324 9.73584 28.3218 9.73584C28.8113 9.73584 29.2069 10.1323 29.2069 10.6209V14.1611C29.2069 14.6497 28.8113 15.0462 28.3218 15.0462Z"
      fill={fill}
    />
    <path
      d="M28.3232 11.5062C28.0462 11.5062 27.7736 11.377 27.601 11.1336C27.3187 10.7353 27.4116 10.1821 27.8099 9.8998L41.5283 0.164169C41.9274 -0.118165 42.4788 -0.0252338 42.7629 0.373927C43.0452 0.772203 42.9523 1.32536 42.554 1.6077L28.8356 11.3433C28.679 11.4531 28.5002 11.5062 28.3232 11.5062Z"
      fill={fill}
    />
    <path
      d="M55.7577 11.5061C55.5807 11.5061 55.4019 11.453 55.2462 11.3424L41.5278 1.60672C41.1295 1.32439 41.0357 0.771226 41.3189 0.372951C41.6021 -0.0262104 42.1535 -0.119141 42.5536 0.163192L56.272 9.89882C56.6702 10.1812 56.764 10.7343 56.4808 11.1326C56.3074 11.3769 56.0356 11.5061 55.7577 11.5061Z"
      fill={fill}
    />
    <path
      d="M28.3232 15.0462C28.0462 15.0462 27.7736 14.917 27.601 14.6736C27.3187 14.2753 27.4116 13.7222 27.8099 13.4398L41.5283 3.70421C41.9274 3.42187 42.4788 3.51481 42.7629 3.91397C43.0452 4.31224 42.9523 4.8654 42.554 5.14774L28.8356 14.8834C28.679 14.9931 28.5002 15.0462 28.3232 15.0462Z"
      fill={fill}
    />
    <path
      d="M55.7577 15.0461C55.5807 15.0461 55.4019 14.993 55.2462 14.8824L41.5278 5.14676C41.1295 4.86443 41.0357 4.31127 41.3189 3.91299C41.6021 3.51383 42.1535 3.4209 42.5536 3.70323L56.272 13.4389C56.6702 13.7212 56.764 14.2744 56.4808 14.6726C56.3074 14.9169 56.0356 15.0461 55.7577 15.0461Z"
      fill={fill}
    />
    <path
      d="M28.3218 52.2186C27.8324 52.2186 27.4368 51.823 27.4368 51.3335V10.6209C27.4368 10.1323 27.8324 9.73584 28.3218 9.73584C28.8113 9.73584 29.2069 10.1323 29.2069 10.6209V51.3335C29.2069 51.823 28.8113 52.2186 28.3218 52.2186Z"
      fill={fill}
    />
    <path
      d="M55.7586 15.0462C55.2692 15.0462 54.8735 14.6497 54.8735 14.1611V10.6209C54.8735 10.1323 55.2692 9.73584 55.7586 9.73584C56.248 9.73584 56.6437 10.1323 56.6437 10.6209V14.1611C56.6437 14.6497 56.248 15.0462 55.7586 15.0462Z"
      fill={fill}
    />
    <path
      d="M55.7586 52.2189C55.2692 52.2189 54.8735 51.8233 54.8735 51.3338V14.1614C54.8735 13.6729 55.2692 13.2764 55.7586 13.2764C56.248 13.2764 56.6437 13.6729 56.6437 14.1614V51.3338C56.6437 51.8233 56.248 52.2189 55.7586 52.2189Z"
      fill={fill}
    />
    <path
      d="M0.885057 52.2189C0.395621 52.2189 0 51.8233 0 51.3338V14.1614C0 13.6729 0.395621 13.2764 0.885057 13.2764C1.37449 13.2764 1.77011 13.6729 1.77011 14.1614V51.3338C1.77011 51.8233 1.37449 52.2189 0.885057 52.2189Z"
      fill={fill}
    />
    <path
      d="M34.5173 52.2188H22.1265C21.6371 52.2188 21.2415 51.8232 21.2415 51.3338V38.0579C21.2415 37.5685 21.6371 37.1729 22.1265 37.1729H34.5173C35.0068 37.1729 35.4024 37.5685 35.4024 38.0579V51.3338C35.4024 51.8232 35.0068 52.2188 34.5173 52.2188ZM23.0116 50.4487H33.6323V38.943H23.0116V50.4487Z"
      fill={fill}
    />
    <path
      d="M31.004 45.1383C30.5145 45.1383 30.1145 44.7427 30.1145 44.2532C30.1145 43.7638 30.5057 43.3682 30.9942 43.3682H31.004C31.4925 43.3682 31.889 43.7638 31.889 44.2532C31.889 44.7427 31.4925 45.1383 31.004 45.1383Z"
      fill={fill}
    />
    <path
      d="M25.6937 45.1383C25.2042 45.1383 24.8042 44.7427 24.8042 44.2532C24.8042 43.7638 25.1954 43.3682 25.6839 43.3682H25.6937C26.1822 43.3682 26.5787 43.7638 26.5787 44.2532C26.5787 44.7427 26.1822 45.1383 25.6937 45.1383Z"
      fill={fill}
    />
    <path
      d="M55.7586 31.8624H0.885057C0.395621 31.8624 0 31.4668 0 30.9773C0 30.4879 0.395621 30.0923 0.885057 30.0923H55.7586C56.2481 30.0923 56.6437 30.4879 56.6437 30.9773C56.6437 31.4668 56.2481 31.8624 55.7586 31.8624Z"
      fill={fill}
    />
    <path
      d="M20.3564 18.1441C19.8669 18.1441 19.4713 17.7476 19.4713 17.259C19.4713 14.5746 17.287 12.3912 14.6035 12.3912C11.92 12.3912 9.73569 14.5746 9.73569 17.259C9.73569 17.7476 9.34007 18.1441 8.85063 18.1441C8.3612 18.1441 7.96558 17.7476 7.96558 17.259C7.96558 13.5984 10.9429 10.6211 14.6035 10.6211C18.2641 10.6211 21.2414 13.5984 21.2414 17.259C21.2414 17.7476 20.8458 18.1441 20.3564 18.1441Z"
      fill={fill}
    />
    <path
      d="M4.42534 31.8626C3.9359 31.8626 3.54028 31.467 3.54028 30.9775V23.012C3.54028 22.5235 3.9359 22.127 4.42534 22.127C4.91478 22.127 5.3104 22.5235 5.3104 23.012V30.9775C5.3104 31.467 4.91478 31.8626 4.42534 31.8626Z"
      fill={fill}
    />
    <path
      d="M7.96562 31.8626C7.47619 31.8626 7.08057 31.467 7.08057 30.9775V23.012C7.08057 22.5235 7.47619 22.127 7.96562 22.127C8.45506 22.127 8.85068 22.5235 8.85068 23.012V30.9775C8.85068 31.467 8.45506 31.8626 7.96562 31.8626Z"
      fill={fill}
    />
    <path
      d="M12.3909 31.8626C11.9015 31.8626 11.5059 31.467 11.5059 30.9775V23.012C11.5059 22.5235 11.9015 22.127 12.3909 22.127C12.8804 22.127 13.276 22.5235 13.276 23.012V30.9775C13.276 31.467 12.8804 31.8626 12.3909 31.8626Z"
      fill={fill}
    />
    <path
      d="M16.8162 31.8626C16.3268 31.8626 15.9312 31.467 15.9312 30.9775V23.012C15.9312 22.5235 16.3268 22.127 16.8162 22.127C17.3056 22.127 17.7013 22.5235 17.7013 23.012V30.9775C17.7013 31.467 17.3056 31.8626 16.8162 31.8626Z"
      fill={fill}
    />
    <path
      d="M21.2413 31.8626C20.7518 31.8626 20.3562 31.467 20.3562 30.9775V23.012C20.3562 22.5235 20.7518 22.127 21.2413 22.127C21.7307 22.127 22.1263 22.5235 22.1263 23.012V30.9775C22.1263 31.467 21.7307 31.8626 21.2413 31.8626Z"
      fill={fill}
    />
    <path
      d="M24.7815 31.8626C24.2921 31.8626 23.8965 31.467 23.8965 30.9775V23.012C23.8965 22.5235 24.2921 22.127 24.7815 22.127C25.271 22.127 25.6666 22.5235 25.6666 23.012V30.9775C25.6666 31.467 25.271 31.8626 24.7815 31.8626Z"
      fill={fill}
    />
    <path
      d="M24.7817 23.8971H4.42534C3.9359 23.8971 3.54028 23.5006 3.54028 23.012C3.54028 22.5235 3.9359 22.127 4.42534 22.127H24.7817C25.2711 22.127 25.6667 22.5235 25.6667 23.012C25.6667 23.5006 25.2711 23.8971 24.7817 23.8971Z"
      fill={fill}
    />
    <path
      d="M8.85063 23.897C8.3612 23.897 7.96558 23.5005 7.96558 23.012V17.2591C7.96558 16.7705 8.3612 16.374 8.85063 16.374C9.34007 16.374 9.73569 16.7705 9.73569 17.2591V23.012C9.73569 23.5005 9.34007 23.897 8.85063 23.897Z"
      fill={fill}
    />
    <path
      d="M20.3562 23.897C19.8668 23.897 19.4712 23.5005 19.4712 23.012V17.2591C19.4712 16.7705 19.8668 16.374 20.3562 16.374C20.8457 16.374 21.2413 16.7705 21.2413 17.2591V23.012C21.2413 23.5005 20.8457 23.897 20.3562 23.897Z"
      fill={fill}
    />
    <path
      d="M20.3564 18.5865H8.85063C8.3612 18.5865 7.96558 18.19 7.96558 17.7015C7.96558 17.2129 8.3612 16.8164 8.85063 16.8164H20.3564C20.8458 16.8164 21.2414 17.2129 21.2414 17.7015C21.2414 18.19 20.8458 18.5865 20.3564 18.5865Z"
      fill={fill}
    />
    <path
      d="M47.7931 18.1441C47.3037 18.1441 46.9081 17.7476 46.9081 17.259C46.9081 14.5746 44.7238 12.3912 42.0403 12.3912C39.3568 12.3912 37.1725 14.5746 37.1725 17.259C37.1725 17.7476 36.7768 18.1441 36.2874 18.1441C35.798 18.1441 35.4023 17.7476 35.4023 17.259C35.4023 13.5984 38.3797 10.6211 42.0403 10.6211C45.7009 10.6211 48.6782 13.5984 48.6782 17.259C48.6782 17.7476 48.2826 18.1441 47.7931 18.1441Z"
      fill={fill}
    />
    <path
      d="M31.8621 31.8626C31.3727 31.8626 30.9771 31.467 30.9771 30.9775V23.012C30.9771 22.5235 31.3727 22.127 31.8621 22.127C32.3515 22.127 32.7472 22.5235 32.7472 23.012V30.9775C32.7472 31.467 32.3515 31.8626 31.8621 31.8626Z"
      fill={fill}
    />
    <path
      d="M35.4024 31.8626C34.913 31.8626 34.5173 31.467 34.5173 30.9775V23.012C34.5173 22.5235 34.913 22.127 35.4024 22.127C35.8918 22.127 36.2874 22.5235 36.2874 23.012V30.9775C36.2874 31.467 35.8918 31.8626 35.4024 31.8626Z"
      fill={fill}
    />
    <path
      d="M39.8277 31.8626C39.3382 31.8626 38.9426 31.467 38.9426 30.9775V23.012C38.9426 22.5235 39.3382 22.127 39.8277 22.127C40.3171 22.127 40.7127 22.5235 40.7127 23.012V30.9775C40.7127 31.467 40.3171 31.8626 39.8277 31.8626Z"
      fill={fill}
    />
    <path
      d="M44.253 31.8626C43.7635 31.8626 43.3679 31.467 43.3679 30.9775V23.012C43.3679 22.5235 43.7635 22.127 44.253 22.127C44.7424 22.127 45.138 22.5235 45.138 23.012V30.9775C45.138 31.467 44.7424 31.8626 44.253 31.8626Z"
      fill={fill}
    />
    <path
      d="M48.6783 31.8626C48.1888 31.8626 47.7932 31.467 47.7932 30.9775V23.012C47.7932 22.5235 48.1888 22.127 48.6783 22.127C49.1677 22.127 49.5633 22.5235 49.5633 23.012V30.9775C49.5633 31.467 49.1677 31.8626 48.6783 31.8626Z"
      fill={fill}
    />
    <path
      d="M52.2183 31.8626C51.7289 31.8626 51.3333 31.467 51.3333 30.9775V23.012C51.3333 22.5235 51.7289 22.127 52.2183 22.127C52.7077 22.127 53.1034 22.5235 53.1034 23.012V30.9775C53.1034 31.467 52.7077 31.8626 52.2183 31.8626Z"
      fill={fill}
    />
    <path
      d="M52.2184 23.8971H31.8621C31.3727 23.8971 30.9771 23.5006 30.9771 23.012C30.9771 22.5235 31.3727 22.127 31.8621 22.127H52.2184C52.7079 22.127 53.1035 22.5235 53.1035 23.012C53.1035 23.5006 52.7079 23.8971 52.2184 23.8971Z"
      fill={fill}
    />
    <path
      d="M36.2874 23.897C35.798 23.897 35.4023 23.5005 35.4023 23.012V17.2591C35.4023 16.7705 35.798 16.374 36.2874 16.374C36.7768 16.374 37.1725 16.7705 37.1725 17.2591V23.012C37.1725 23.5005 36.7768 23.897 36.2874 23.897Z"
      fill={fill}
    />
    <path
      d="M47.793 23.897C47.3036 23.897 46.908 23.5005 46.908 23.012V17.2591C46.908 16.7705 47.3036 16.374 47.793 16.374C48.2825 16.374 48.6781 16.7705 48.6781 17.2591V23.012C48.6781 23.5005 48.2825 23.897 47.793 23.897Z"
      fill={fill}
    />
    <path
      d="M47.7931 18.5865H36.2874C35.798 18.5865 35.4023 18.19 35.4023 17.7015C35.4023 17.2129 35.798 16.8164 36.2874 16.8164H47.7931C48.2826 16.8164 48.6782 17.2129 48.6782 17.7015C48.6782 18.19 48.2826 18.5865 47.7931 18.5865Z"
      fill={fill}
    />
    <path
      d="M51.3333 45.1383H38.0574C37.568 45.1383 37.1724 44.7426 37.1724 44.2532V35.4026C37.1724 34.9132 37.568 34.5176 38.0574 34.5176H51.3333C51.8227 34.5176 52.2183 34.9132 52.2183 35.4026V44.2532C52.2183 44.7426 51.8227 45.1383 51.3333 45.1383ZM38.9425 43.3682H50.4482V36.2877H38.9425V43.3682Z"
      fill={fill}
    />
    <path
      d="M51.3333 40.713H38.0574C37.568 40.713 37.1724 40.3174 37.1724 39.8279C37.1724 39.3385 37.568 38.9429 38.0574 38.9429H51.3333C51.8227 38.9429 52.2183 39.3385 52.2183 39.8279C52.2183 40.3174 51.8227 40.713 51.3333 40.713Z"
      fill={fill}
    />
    <path
      d="M42.4827 45.1383C41.9933 45.1383 41.5977 44.7426 41.5977 44.2532V35.4026C41.5977 34.9132 41.9933 34.5176 42.4827 34.5176C42.9722 34.5176 43.3678 34.9132 43.3678 35.4026V44.2532C43.3678 44.7426 42.9722 45.1383 42.4827 45.1383Z"
      fill={fill}
    />
    <path
      d="M46.908 45.1383C46.4186 45.1383 46.0229 44.7426 46.0229 44.2532V35.4026C46.0229 34.9132 46.4186 34.5176 46.908 34.5176C47.3974 34.5176 47.7931 34.9132 47.7931 35.4026V44.2532C47.7931 44.7426 47.3974 45.1383 46.908 45.1383Z"
      fill={fill}
    />
    <path
      d="M18.5862 45.1383H5.31035C4.82091 45.1383 4.42529 44.7426 4.42529 44.2532V35.4026C4.42529 34.9132 4.82091 34.5176 5.31035 34.5176H18.5862C19.0756 34.5176 19.4713 34.9132 19.4713 35.4026V44.2532C19.4713 44.7426 19.0756 45.1383 18.5862 45.1383ZM6.19541 43.3682H17.7012V36.2877H6.19541V43.3682Z"
      fill={fill}
    />
    <path
      d="M18.5862 40.713H5.31035C4.82091 40.713 4.42529 40.3174 4.42529 39.8279C4.42529 39.3385 4.82091 38.9429 5.31035 38.9429H18.5862C19.0756 38.9429 19.4713 39.3385 19.4713 39.8279C19.4713 40.3174 19.0756 40.713 18.5862 40.713Z"
      fill={fill}
    />
    <path
      d="M9.73564 45.1383C9.24621 45.1383 8.85059 44.7426 8.85059 44.2532V35.4026C8.85059 34.9132 9.24621 34.5176 9.73564 34.5176C10.2251 34.5176 10.6207 34.9132 10.6207 35.4026V44.2532C10.6207 44.7426 10.2251 45.1383 9.73564 45.1383Z"
      fill={fill}
    />
    <path
      d="M14.1609 45.1383C13.6715 45.1383 13.2759 44.7426 13.2759 44.2532V35.4026C13.2759 34.9132 13.6715 34.5176 14.1609 34.5176C14.6504 34.5176 15.046 34.9132 15.046 35.4026V44.2532C15.046 44.7426 14.6504 45.1383 14.1609 45.1383Z"
      fill={fill}
    />
    <path
      d="M55.7586 52.2188H0.885057C0.395621 52.2188 0 51.8232 0 51.3338C0 50.8444 0.395621 50.4487 0.885057 50.4487H55.7586C56.2481 50.4487 56.6437 50.8444 56.6437 51.3338C56.6437 51.8232 56.2481 52.2188 55.7586 52.2188Z"
      fill={fill}
    />
  </svg>
)

export default DuplexTriplex
